module.exports = __webpack_public_path__ + "assets/f745757997dd6ccb615dde59a286335d.png";